import React from 'react';
import { AutoComplete, Select as AntSelect, Button, Input } from 'antd';
import { Search, X } from 'lucide-react';
import { FilterBar, FilterField } from '../../common';
import { useTableActions } from './tableActions.controller';

/** Search + canal / cliente filters above the stores table. */
export default function TableActions({ setRows, storesData }) {
    const {
        suggestions,
        searchValue,
        setSearchValue,
        channel,
        client,
        clients,
        hasActiveFilters,
        onSearch,
        onChangeChannel,
        onChangeClient,
        clearFilters
    } = useTableActions({ setRows, storesData });

    return (
        <FilterBar
            actions={
                hasActiveFilters && (
                    <Button type="text" icon={<X />} onClick={clearFilters}>
                        Limpiar filtros
                    </Button>
                )
            }>
            <FilterField label="Buscar" width={288}>
                <AutoComplete
                    value={searchValue}
                    options={suggestions.map((value) => ({ value }))}
                    onSearch={onSearch}
                    onSelect={onSearch}
                    onChange={(value) => setSearchValue(value)}
                    placeholder="Buscar piso de venta..."
                    className="w-full"
                    allowClear
                    notFoundContent="No se encontraron resultados"
                    filterOption={false}>
                    <Input prefix={<Search className="text-surface-400" />} />
                </AutoComplete>
            </FilterField>

            <FilterField label="Canal" width={160}>
                <AntSelect
                    className="w-full"
                    value={channel}
                    onChange={onChangeChannel}
                    options={[
                        { value: 'both', label: 'Todos' },
                        { value: 'moderno', label: 'Moderno' },
                        { value: 'tradicional', label: 'Tradicional' }
                    ]}
                />
            </FilterField>

            <FilterField label="Cliente" width={240}>
                <AntSelect
                    showSearch
                    className="w-full"
                    value={client}
                    onChange={onChangeClient}
                    placeholder="Seleccionar cliente"
                    popupMatchSelectWidth={false}
                    dropdownStyle={{ minWidth: 280 }}
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                    options={[{ value: 'both', label: 'Todos' }, ...clients?.map((c) => ({ value: c, label: c }))]}
                />
            </FilterField>
        </FilterBar>
    );
}
